import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { taskboxActions } from "../../store/TaskboxSlice";
import {
  approveTaskRequestChange,
  getAllTaskboxItems,
} from "../../store/TaskboxSlice/thunk";
import DownloadIcon from "../../assets/icons/download.svg";
import Document from "../../assets/images/doc.png";
import ArrowbackIcon from "../../assets/icons/arrow_back.svg";
import GroupIcon from "../../assets/icons/groups.svg";
import DoneIcon from "../../assets/icons/done_all_white.svg";
import CancelIcon from "../../assets/icons/close_white.svg";
import ViewTask from "../../assets/icons/splitscreen_bottom.svg";
import InitialsCircle from "../../components/InitialsCircle";
import CustomDropdown from "../../commonComponents/CustomDropdown";
import CustomInput from "../../commonComponents/CustomInput";
import {
  getDropDownList,
  searchUserDetails,
} from "../../store/PeopleSlice/thunk";
import "./TaskBox.css";

const TaskBox = () => {
  const empColor = ["#DA3D09", "#D0213D", "#0062E2", "#784CD5", "#008A29"];

  const [taskList, setTaskList] = useState([]);
  const [taskSummaryView, setTaskSummaryView] = useState(true);
  const [empSelected, setEmpSelected] = useState(null);
  const [requestRemarks, setRequestRemarks] = useState("");
  const [isEditingProposedFields, setIsEditingProposedFields] = useState(false);
  const [editedProposedFields, setEditedProposedFields] = useState({});
  const [hasEditedProposedFields, setHasEditedProposedFields] = useState(false);
  const [managerSearchText, setManagerSearchText] = useState("");
  const [managerSearchEnabled, setManagerSearchEnabled] = useState(false);
  const [showManagerResults, setShowManagerResults] = useState(false);
  const [openManagerResultsUpward, setOpenManagerResultsUpward] =
    useState(false);
  const [offset, setOffset] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const listContainerRef = useRef(null);
  const managerSearchContainerRef = useRef(null);
  const limit = 10;

  const getAllTaskboxResponse = useSelector(
    (state) => state.taskbox.getAllTaskboxResponse,
  );

  const getAllTaskboxResponseStatus = useSelector(
    (state) => state.taskbox.getAllTaskboxResponseStatus,
  );

  const approveTaskRequestChangeResponse = useSelector(
    (state) => state.taskbox.approveTaskRequestChangeResponse,
  );

  const approveTaskRequestChangeResponseStatus = useSelector(
    (state) => state.taskbox.approveTaskRequestChangeResponseStatus,
  );

  const fullName = useSelector(
    (state) => state.auth?.loginResponse?.display_name || "",
  );
  const dropDownData = useSelector(
    (state) => state.people?.dropDownListResponse?.data || {},
  );
  const searchList = useSelector((state) => state.people?.searchList);
  const searchListStatus = useSelector(
    (state) => state.people?.searchListStatus,
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(taskboxActions.resetApproveTaskRequestChange());

    setTaskList([]);
    setOffset(0);
    setHasMore(true);
    dispatch(
      getAllTaskboxItems({
        offset: 0,
        limit,
        request_type: "taskbox",
      }),
    );
    dispatch(getDropDownList({}));
  }, [dispatch]);

  useEffect(() => {
    if (
      !isEditingProposedFields ||
      !managerSearchEnabled ||
      managerSearchText.trim().length < 3
    )
      return;
    const timeout = setTimeout(() => {
      dispatch(searchUserDetails({ id_or_name: managerSearchText.trim() }));
    }, 500);
    return () => clearTimeout(timeout);
  }, [
    dispatch,
    isEditingProposedFields,
    managerSearchEnabled,
    managerSearchText,
  ]);

  useEffect(() => {
    if (!showManagerResults) return;
    const handleClickOutside = (event) => {
      if (
        managerSearchContainerRef.current &&
        !managerSearchContainerRef.current.contains(event.target)
      ) {
        setShowManagerResults(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showManagerResults]);

  useEffect(() => {
    dispatch(taskboxActions.settotalTaskLength(taskList?.length || 0));
  }, [taskList]);

  const loadMore = () => {
    if (loadingMore || !hasMore) return;
    setLoadingMore(true);
    const nextOffset = offset + limit;
    setOffset(nextOffset);
    dispatch(
      getAllTaskboxItems({
        offset: nextOffset,
        limit,
        request_type: "taskbox",
      }),
    );
  };

  const handleScroll = (e) => {
    const target = e.target;
    const { scrollTop, scrollHeight, clientHeight } = target;
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      loadMore();
    }
  };

  useEffect(() => {
    if (getAllTaskboxResponseStatus === "SUCCESS") {
      const newData = getAllTaskboxResponse?.data || [];
      if (loadingMore) {
        setTaskList((prev) => [...prev, ...newData]);
      } else {
        setTaskList(newData);
        setTaskSummaryView(true);
        setEmpSelected(null);
      }
      setLoadingMore(false);
      setHasMore(newData.length === limit);
      setRequestRemarks("");
    } else if (getAllTaskboxResponseStatus === "ERROR") {
      setLoadingMore(false);
    }
  }, [getAllTaskboxResponseStatus]);

  useEffect(() => {
    if (approveTaskRequestChangeResponseStatus === "SUCCESS") {
      console.log(
        "\n\napproveTaskRequestChangeResponse : ",
        approveTaskRequestChangeResponse,
      );

      setTaskList([]);
      dispatch(
        getAllTaskboxItems({
          offset: 0,
          limit: 20,
          request_type: "taskbox",
        }),
      );
    } else if (approveTaskRequestChangeResponseStatus === "ERROR") {
      console.log(
        "\n\napproveTaskRequestChangeResponse : ",
        approveTaskRequestChangeResponse,
      );
    }
  }, [approveTaskRequestChangeResponseStatus]);

  useEffect(() => {
    console.log("\n\nempselected : ", empSelected);
  }, [empSelected]);

  const onEmpTaskSelected = (item) => {
    setEmpSelected(item);
    const newValue = getRequestNewValue(item);
    setEditedProposedFields(getProposedFields(item, newValue));
    setHasEditedProposedFields(false);
    setManagerSearchText(
      String(newValue.manager_id || newValue.new_manager || ""),
    );
    setManagerSearchEnabled(false);
    setIsEditingProposedFields(false);
    setTaskSummaryView(false);
  };

  const getRequestNewValue = (item) => {
    if (!item?.new_value) return {};
    if (typeof item.new_value === "object") return item.new_value;
    try {
      return JSON.parse(item.new_value);
    } catch (error) {
      return {};
    }
  };

  const getRequestOldValue = (item) => {
    if (!item?.old_value) return {};
    if (typeof item.old_value === "object") return item.old_value;
    try {
      return JSON.parse(item.old_value);
    } catch (error) {
      return {};
    }
  };

  const getProposedFields = (item, newValue = getRequestNewValue(item)) => ({
    work_area_code_x: newValue.work_area_code_x || item?.new_location || "",
    designation: newValue.designation || newValue.new_designation || "",
    manager_id: newValue.manager_id || newValue.new_manager || "",
    employment_type:
      newValue.employment_type ||
      newValue.new_employment_type ||
      item?.employment_type ||
      "",
    channel: newValue.channel || newValue.new_channel || item?.channel || "",
    attendance_shift: newValue.attendance_shift || item?.attendance_shift || "",
    attendance_policy:
      newValue.attendance_policy || item?.attendance_policy || "",
    attendance_weeklyoff:
      newValue.attendance_weeklyoff || item?.attendance_weeklyoff || "",
  });

  const updateProposedField = (field, value) => {
    setHasEditedProposedFields(true);
    setEditedProposedFields((current) => ({ ...current, [field]: value }));
  };

  const handleManagerSearchChange = (value) => {
    setManagerSearchText(value);
    setManagerSearchEnabled(true);
    setShowManagerResults(value.trim().length >= 3);
  };

  const selectManager = (manager) => {
    setManagerSearchEnabled(false);
    setShowManagerResults(false);
    setManagerSearchText(
      `${manager?.full_name || manager?.first_name} - ${manager.employee_id}`,
    );
    updateProposedField("manager_id", manager.employee_id);
  };

  const openManagerSearchResults = () => {
    if (managerSearchText.trim().length < 3) return;
    const rect = managerSearchContainerRef.current?.getBoundingClientRect();
    if (rect) {
      setOpenManagerResultsUpward(rect.top > window.innerHeight / 2);
      setShowManagerResults(true);
    }
  };

  const renderProposedDropdown = (label, field, options) => (
    <div className="profile-detail-box br-d-t">
      {isEditingProposedFields ? (
        <CustomDropdown
          showOptional
          label={label}
          className="emp-form-input"
          options={options || []}
          value={editedProposedFields[field] || ""}
          onSelectOption={(value) => updateProposedField(field, value)}
          isRequired={false}
        />
      ) : (
        <>
          <div className="profile-detail-label">{label}</div>
          <div className="profile-detail-value">
            {editedProposedFields[field] || "-"}
          </div>
        </>
      )}
    </div>
  );

  const renderProposedManager = () => (
    <div
      className="profile-detail-box br-d-t tb-manager-search-container"
      ref={managerSearchContainerRef}
      onClick={openManagerSearchResults}
    >
      {isEditingProposedFields ? (
        <>
          <CustomInput
            label="Proposed Manager"
            editable
            value={managerSearchText}
            placeholder="Search proposed manager"
            onChange={handleManagerSearchChange}
            isRequired={false}
            validationStr={/^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/}
          />
          {showManagerResults && managerSearchText.trim().length >= 3 && (
            <div
              className={`tb-manager-search-results ${
                openManagerResultsUpward ? "open-upward" : ""
              }`}
              onClick={(event) => event.stopPropagation()}
            >
              {searchListStatus === "PENDING" ? (
                <div className="tb-manager-search-empty">Searching...</div>
              ) : searchList?.user_details?.length ? (
                searchList.user_details.map((manager) => (
                  <button
                    key={manager.employee_id}
                    type="button"
                    className="tb-manager-search-result"
                    onClick={() => selectManager(manager)}
                  >
                    <span>{manager.full_name || manager.first_name}</span>
                    <span> • Employee ID #{manager.employee_id}</span>
                  </button>
                ))
              ) : (
                <div className="tb-manager-search-empty">
                  No employees found
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="profile-detail-label">Proposed Manager</div>
          <div className="profile-detail-value">
            {editedProposedFields.manager_id || "-"}
          </div>
        </>
      )}
    </div>
  );

  const submitTask = (data) => {
    const item = data.item;
    const payload = {
      id: item?.id,
      approve_status: data?.status,
      hr_remarks: requestRemarks,
      employee_id: item?.employee_id,
    };
    if (
      item?.request_type !== "Location" &&
      item?.request_type !== "Shift Change"
    ) {
      payload.request_type = item?.request_type;
    }
    if (
      data?.status === "Approved" &&
      hasEditedProposedFields &&
      ["Location", "Shift Change"].includes(item?.request_type)
    ) {
      const originalNewValue = getRequestNewValue(item);
      const updatedNewValue = { ...originalNewValue };
      const setExistingField = (existingKeys, fallbackKey, value) => {
        const key = existingKeys.find((existingKey) =>
          Object.prototype.hasOwnProperty.call(originalNewValue, existingKey),
        );
        updatedNewValue[key || fallbackKey] = value;
      };

      if (item.request_type === "Location") {
        updatedNewValue.work_area_code_x =
          editedProposedFields.work_area_code_x;
        setExistingField(
          ["designation", "new_designation"],
          "designation",
          editedProposedFields.designation,
        );
        setExistingField(
          ["manager_id", "new_manager"],
          "manager_id",
          editedProposedFields.manager_id,
        );
        setExistingField(
          ["employment_type", "new_employment_type"],
          "employment_type",
          editedProposedFields.employment_type,
        );
        setExistingField(
          ["channel", "new_channel"],
          "channel",
          editedProposedFields.channel,
        );
      } else {
        updatedNewValue.attendance_shift =
          editedProposedFields.attendance_shift;
        updatedNewValue.attendance_policy =
          editedProposedFields.attendance_policy;
        updatedNewValue.attendance_weeklyoff =
          editedProposedFields.attendance_weeklyoff;
      }
      payload.new_value = JSON.stringify(updatedNewValue);
    }
    dispatch(approveTaskRequestChange(payload));
  };

  const getCtcDetails = (item) => {
    if (!item?.new_value) return item || {};
    try {
      return {
        ...item,
        ...JSON.parse(item.new_value),
      };
    } catch (error) {
      return item;
    }
  };

  const CtcRevisionSummaryRowCard = ({ item }) => {
    const details = getCtcDetails(item);
    return (
      <div className="summary-container ctc-task-row">
        <div className="header-container">
          <div className="summary-header">
            <div className="summary-emp-id">
              Employee ID #{item.employee_id}
            </div>
            <div className="emp-logo-box">
              <InitialsCircle fullName={item?.full_name} size={24} />
              <div className="summary-emp-name">{item.full_name}</div>
              <div className="spacer-dot">•</div>
              <div className="summary-loc">CTC Revision</div>
            </div>
          </div>
          <div className="ml-auto flex items-center">
            <div
              className="pf-pr-btn view-task-btn"
              onClick={() => onEmpTaskSelected(item)}
            >
              <img src={ViewTask} alt="" className="mr-2" />
              View Task
            </div>
          </div>
        </div>
        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details">
            <div className="row-item-heading">Current CTC</div>
            <div className="row-item-value">
              {JSON.parse(item?.old_value)?.monthly_gross}
            </div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading">Proposed CTC</div>
            <div className="row-item-value">
              {JSON.parse(item?.new_value)?.monthly_gross}
            </div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading">Effective From</div>
            <div className="row-item-value">
              {details.effective_from || item.effective_date || "-"}
            </div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading">Status</div>
            <div className="row-item-value">{item.status || "Pending"}</div>
          </div>
        </div>
      </div>
    );
  };

  const CtcRevisionDetails = ({ item }) => {
    const details = getCtcDetails(item);

    return (
      <>
        <div className="profile-detail-table ctc-revision-table">
          <div className="flex w-full bb-d-t">
            <div className="profile-detail-box br-d-t">
              <div className="profile-detail-label">
                Current CTC (monthly fixed)
              </div>
              <div className="profile-detail-value">
                {JSON.parse(details?.old_value)?.monthly_gross}
              </div>
            </div>
            <div className="profile-detail-box br-d-t">
              <div className="profile-detail-label">Proposed CTC</div>
              <div className="profile-detail-value">
                {JSON.parse(details?.new_value)?.monthly_gross}
              </div>
            </div>
            <div className="profile-detail-box">
              <div className="profile-detail-label">Variance vs current</div>
              <div className="profile-detail-value ctc-variance-value">
                {details.variance_pct == null
                  ? "-"
                  : `+${details.variance_pct}%`}
              </div>
            </div>
          </div>
          <div className="flex w-full bb-d-t">
            <div className="profile-detail-box br-d-t">
              <div className="profile-detail-label">Effective from</div>
              <div className="profile-detail-value">
                {details.effective_from || item.effective_date || "-"}
              </div>
            </div>
            <div className="profile-detail-box br-d-t">
              <div className="profile-detail-label">Uploaded by</div>
              <div className="profile-detail-value">
                {details.uploaded_by || item.initiator_full_name || "-"}
              </div>
            </div>
            <div className="profile-detail-box">
              <div className="profile-detail-label">Upload batch</div>
              <div className="profile-detail-value">
                {details.upload_batch || details.file_name || "-"}
              </div>
            </div>
          </div>
          <div className="flex w-full">
            <div className="profile-detail-box br-d-t">
              <div className="profile-detail-label">Trigger date</div>
              <div className="profile-detail-value">
                {details.trigger_date || item.effective_date || "-"}
              </div>
            </div>
            <div className="profile-detail-box br-d-t">
              <div className="profile-detail-label">Grade</div>
              <div className="profile-detail-value">{details.grade || "-"}</div>
            </div>
            <div className="profile-detail-box">
              <div className="profile-detail-label">Reason on file</div>
              <div className="profile-detail-value">
                {details.reason_on_file || details.reason || "-"}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const LocationSummaryRowCard = ({ item, index }) => {
    return (
      <div className="summary-container" index={index}>
        <div className="header-container">
          <div className="summary-header">
            <div className="summary-emp-id">
              Employee ID #{item.employee_id}
            </div>

            <div className="emp-logo-box">
              {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
              <InitialsCircle fullName={item?.full_name} size={24} />
              <div className="summary-emp-name">{item.full_name}</div>

              <div className="spacer-dot">•</div>

              <div className="summary-loc">Location Change</div>
            </div>
          </div>

          <div className="ml-auto flex items-center">
            <div
              className="pf-pr-btn view-task-btn"
              onClick={() => onEmpTaskSelected(item)}
            >
              <img src={ViewTask} alt="" className="mr-2" />
              View Task
            </div>
            {item.status !== "Approved" && (
              <>
                <div
                  className="pf-pr-btn cancel-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Rejected" });
                  }}
                >
                  <img src={CancelIcon} alt="" className="mr-2" />
                  Reject
                </div>
                <div
                  className="pf-pr-btn update-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Approved" });
                  }}
                >
                  <img src={DoneIcon} alt="" className="mr-2" />
                  Approve
                </div>
              </>
            )}
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details w-40">
            <div className="row-item-heading">Proposed Location / Store</div>
            <div className="row-item-value">
              {item.new_location +
                " - " +
                JSON.parse(item?.new_value)?.work_area_code_x}
            </div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Initiated By</div>
            <div className="row-item-value">{item.initiator_full_name}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Trigger Date</div>
            <div className="row-item-value">{item.effective_date}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Approval Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Pending" && (
              <div className="row-item-orange">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>

          {/* <div className="summary-row-details">
          <div className="row-item-heading">Workflow Status</div>
          <div className="row-item-orange">
          <div className="color-label-text">
          Pending
          </div>
          </div>
          </div>
          
          <div className="summary-row-details">
          <div className="row-item-heading">Overall Flow Status</div>
          <div className="row-item-red">
          <div className="color-label-text">
          Overdue
          </div>
          </div>
          </div> */}
        </div>
      </div>
    );
  };

  const AttendanceSummaryRowCard = ({ item, index }) => {
    return (
      <div className="summary-container" index={index}>
        <div className="header-container">
          <div className="summary-header">
            <div className="summary-emp-id">
              Employee ID #{item.employee_id}
            </div>

            <div className="emp-logo-box">
              {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
              <InitialsCircle fullName={item?.full_name} size={24} />
              <div className="summary-emp-name">{item.full_name}</div>

              <div className="spacer-dot">•</div>

              <div className="summary-loc">Attendance Shift Change</div>
            </div>
          </div>
          <div className="ml-auto flex items-center">
            <div
              className="pf-pr-btn view-task-btn"
              onClick={() => onEmpTaskSelected(item)}
            >
              <img src={ViewTask} alt="" className="mr-2" />
              View Task
            </div>
            {item.status !== "Approved" && (
              <>
                <div
                  className="pf-pr-btn cancel-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Rejected" });
                  }}
                >
                  <img src={CancelIcon} alt="" className="mr-2" />
                  Reject
                </div>
                <div
                  className="pf-pr-btn update-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Approved" });
                  }}
                >
                  <img src={DoneIcon} alt="" className="mr-2" />
                  Approve
                </div>
              </>
            )}
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details w-40">
            <div className="row-item-heading">Attendance Shift Type</div>
            <div className="row-item-value">
              {JSON.parse(item?.new_value)?.attendance_shift}
            </div>
          </div>

          {/* <div className="summary-row-details">
            <div className="row-item-heading">Policy Type</div>
            <div className="row-item-value">{item.initiator_full_name}</div>
          </div> */}

          <div className="summary-row-details">
            <div className="row-item-heading">Initiated By</div>
            <div className="row-item-value">{item.initiator_full_name}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Trigger Date</div>
            <div className="row-item-value">{item.effective_date}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Approval Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Pending" && (
              <div className="row-item-orange">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const DesignationSummaryRowCard = ({ item, index }) => {
    return (
      <div className="summary-container" index={index}>
        <div className="header-container">
          <div className="summary-header">
            <div className="summary-emp-id">
              Employee ID #{item.employee_id}
            </div>

            <div className="emp-logo-box">
              {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
              <InitialsCircle fullName={item?.full_name} size={24} />
              <div className="summary-emp-name">{item.full_name}</div>

              <div className="spacer-dot">•</div>

              <div className="summary-loc">Designation Change</div>
            </div>
          </div>

          <div className="ml-auto flex items-center">
            <div
              className="pf-pr-btn view-task-btn"
              onClick={() => onEmpTaskSelected(item)}
            >
              <img src={ViewTask} alt="" className="mr-2" />
              View Task
            </div>
            {item.status !== "Approved" && (
              <>
                <div
                  className="pf-pr-btn cancel-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Rejected" });
                  }}
                >
                  <img src={CancelIcon} alt="" className="mr-2" />
                  Reject
                </div>
                <div
                  className="pf-pr-btn update-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Approved" });
                  }}
                >
                  <img src={DoneIcon} alt="" className="mr-2" />
                  Approve
                </div>
              </>
            )}
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details w-40">
            <div className="row-item-heading">Proposed Designation</div>
            <div className="row-item-value">{item.new_location}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Initiated By</div>
            <div className="row-item-value">{item.initiator_full_name}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Trigger Date</div>
            <div className="row-item-value">{item.effective_date}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Approval Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Pending" && (
              <div className="row-item-orange">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Overdue" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const SeperationSummaryRowCard = ({ item, index }) => {
    return (
      <div
        className="summary-container"
        index={index}
        onClick={() => {
          navigate("../taskbox/approve");
          dispatch(taskboxActions.setSeparationEmpData(item));
        }}
        style={{ cursor: "pointer" }}
      >
        <div className="header-container">
          <div className="summary-header">
            <div className="summary-emp-id">
              Employee ID #{item.employee_id}
            </div>

            <div className="emp-logo-box">
              <InitialsCircle fullName={item?.full_name} size={24} />
              <div className="summary-emp-name">{item.full_name}</div>

              <div className="spacer-dot">•</div>

              <div className="summary-loc">{item?.request_type}</div>
            </div>
          </div>

          <div className="ml-auto flex items-center">
            {item.task_action === "Approve" ? (
              <>
                <div
                  className="pf-pr-btn cancel-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Rejected" });
                  }}
                >
                  <img src={CancelIcon} alt="" className="mr-2" />
                  Reject
                </div>
                <div
                  className="pf-pr-btn update-btn ml-2"
                  onClick={() => {
                    submitTask({ item, status: "Approved" });
                  }}
                >
                  <img src={DoneIcon} alt="" className="mr-2" />
                  Approve
                </div>
              </>
            ) : (
              <div
                className="pf-pr-btn view-task-btn"
                onClick={() => onEmpTaskSelected(item)}
              >
                <img src={ViewTask} alt="" className="mr-2" />
                View Task
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row">
          <div className="summary-row-details">
            <div className="row-item-heading">Date of Resignation</div>
            <div className="row-item-value">{item.date_of_resignation}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Final Date Of Exit</div>
            <div className="row-item-value">{item.final_date_of_exit}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Separation Reason</div>
            <div className="row-item-value">{item.reason}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Region</div>
            <div className="row-item-value">{item.region || "N/A"}</div>
          </div>

          <div className="summary-row-details">
            <div className="row-item-heading">Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Pending" && (
              <div className="row-item-orange">
                <div className="color-label-text">Approval Pending</div>
              </div>
            )}
            {item.status === "Overdue" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Approval Pending" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`tb-home ${isEditingProposedFields ? "tb-edit-mode" : ""}`}>
      {taskSummaryView === true ? (
        <>
          <div className="tb-head">
            <div className="head-left-container">
              <button
                type="button"
                aria-label="Back to all modules"
                className="xl:hidden mr-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100 border-0"
                onClick={() => navigate("../all")}
              >
                <img src={ArrowbackIcon} alt="Back" className="h-5 w-5" />
              </button>
              <div className="font-semibold">taskbox</div>
            </div>
          </div>

          <div className="flex rq-create-summary">
            <div
              className="rq-summary-container"
              onScroll={handleScroll}
              ref={listContainerRef}
            >
              {taskList?.length > 0 ? (
                taskList?.map((item, index) => {
                  if (item.request_type === "Location") {
                    return <LocationSummaryRowCard key={index} item={item} />;
                  } else if (item.request_type === "Shift Change") {
                    return <AttendanceSummaryRowCard key={index} item={item} />;
                  } else if (item.request_type === "Designation Change") {
                    return (
                      <DesignationSummaryRowCard key={index} item={item} />
                    );
                  } else if (item.request_type === "CTC Revision") {
                    return (
                      <CtcRevisionSummaryRowCard key={index} item={item} />
                    );
                  } else if (
                    item.request_type === "Separation Approval" ||
                    item.request_type === "IT Clearance" ||
                    item.request_type === "Finance Clearance" ||
                    item.request_type === "Admin Clearance" ||
                    item.request_type === "Payroll Clearance"
                  ) {
                    return <SeperationSummaryRowCard key={index} item={item} />;
                  }
                })
              ) : (
                <div className="rq-summary-empty">No tasks found</div>
              )}
              {loadingMore && (
                <div className="loading-more">Loading more...</div>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="tb-head">
            <div
              className="head-left-container"
              onClick={() => {
                setTaskSummaryView(true);
                setEmpSelected(null);
              }}
            >
              <img
                className="arrow-icon"
                src={ArrowbackIcon}
                alt="arrow-back"
              />

              {empSelected?.request_type === "Location" && "location change"}
              {empSelected?.request_type === "Shift Change" &&
                "attendance shift change"}
              {empSelected?.request_type === "Designation Change" &&
                "designation change"}
              {empSelected?.request_type === "CTC Revision" && "ctc revision"}
            </div>
            <div className="head-right-container ml-auto">
              {empSelected.status !== "Approved" && (
                <>
                  {["Location", "Shift Change"].includes(
                    empSelected?.request_type,
                  ) && (
                    <button
                      type="button"
                      className="pf-pr-btn view-task-btn"
                      onClick={() => {
                        setIsEditingProposedFields((isEditing) => {
                          if (isEditing) {
                            setManagerSearchEnabled(false);
                            setManagerSearchText(
                              String(editedProposedFields.manager_id || ""),
                            );
                            return false;
                          }
                          return true;
                        });
                      }}
                    >
                      {isEditingProposedFields ? "Done" : "Edit"}
                    </button>
                  )}
                  <button
                    type="button"
                    className="pf-pr-btn cancel-btn"
                    disabled={isEditingProposedFields}
                    onClick={() => {
                      submitTask({ item: empSelected, status: "Rejected" });
                    }}
                  >
                    <img src={CancelIcon} alt="" className="mr-2" />
                    Reject
                  </button>
                  <button
                    type="button"
                    className="pf-pr-btn update-btn"
                    disabled={isEditingProposedFields}
                    onClick={() => {
                      submitTask({ item: empSelected, status: "Approved" });
                    }}
                  >
                    <img src={DoneIcon} alt="" className="mr-2" />
                    Approve
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="flex task-create-summary">
            <div className="task-init-form">
              <div className="task-emp-selected">
                <div className="task-emp-header-card">
                  <div className="rq-emp-id">
                    Employee ID #{empSelected?.employee_id}
                  </div>
                  <div className="flex items-center">
                    <div className="flex items-center">
                      <InitialsCircle
                        fullName={empSelected?.full_name}
                        size={24}
                      />
                      <div className="rq-emp-name">
                        {empSelected?.full_name}
                      </div>
                    </div>
                    <div
                      className="flex rq-grp-com"
                      style={{
                        backgroundColor:
                          empColor[Math.floor(Math.random() * 5)],
                      }}
                    >
                      <img
                        className="rq-grp-icon"
                        src={GroupIcon}
                        alt="emp-icon"
                      />
                      <div className="rq-grp-text">
                        {empSelected?.business_unit}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`task-summary-container ${
                  isEditingProposedFields ? "tb-editing" : ""
                }`}
              >
                <div className="task-summary-title">summary</div>

                {empSelected?.request_type === "Location" && (
                  <>
                    <div
                      className={`profile-detail-table ${
                        isEditingProposedFields ? "tb-editing" : ""
                      }`}
                    >
                      <div className="flex w-full bb-d-t">
                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Current Store
                          </div>
                          <div className="profile-detail-value">
                            {empSelected?.old_location}
                          </div>
                        </div>

                        {renderProposedDropdown(
                          "Proposed Store / Location",
                          "work_area_code_x",
                          dropDownData?.location_fin,
                        )}

                        <div className="profile-detail-box">
                          <div className="profile-detail-label">Request By</div>
                          <div className="profile-detail-value">
                            {empSelected?.initiator_full_name}
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full bb-d-t">
                        {renderProposedDropdown(
                          "Proposed Designation",
                          "designation",
                          dropDownData?.designationNameAndCode,
                        )}

                        {renderProposedManager()}

                        <div className="profile-detail-box">
                          <div className="profile-detail-label">
                            Reason for Location Change
                          </div>
                          <div className="profile-detail-value">
                            {empSelected?.request_remarks || "NA"}
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full bb-d-t">
                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Current Designation
                          </div>
                          <div className="profile-detail-value">
                            {JSON.parse(empSelected?.old_value)?.designation}
                          </div>
                        </div>

                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Current Manager
                          </div>
                          <div className="profile-detail-value">
                            {JSON.parse(empSelected?.old_value)?.manager_id}
                          </div>
                        </div>

                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">Distance</div>
                          <div className="profile-detail-value">
                            {empSelected?.distance}
                          </div>
                        </div>
                      </div>
                      <div className="flex w-full bb-d-t">
                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Current Channel
                          </div>
                          <div className="profile-detail-value">
                            {JSON.parse(empSelected?.old_value)?.channel ||
                              "NA"}
                          </div>
                        </div>

                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Current Employment Type
                          </div>
                          <div className="profile-detail-value">
                            {JSON.parse(empSelected?.old_value)
                              ?.employment_type || "NA"}
                          </div>
                        </div>

                        <div className="profile-detail-box" />
                      </div>
                      <div className="d-flex w-100">
                        {renderProposedDropdown("Proposed Channel", "channel", [
                          "Amazon",
                          "Amazon Express",
                          "More",
                          "Omni",
                        ])}
                        {renderProposedDropdown(
                          "Proposed Employment Type",
                          "employment_type",
                          ["FT", "PT"],
                        )}

                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label"></div>
                          <div className="profile-detail-value"></div>
                        </div>
                      </div>
                    </div>

                    {empSelected?.attachments && (
                      <div className="attachment-file-container">
                        <div className="task-summary-title">attachment</div>
                        <div className="file-box">
                          <div className="file-box-top">
                            <div className="document-img-container">
                              <img
                                src={Document}
                                className="document-img"
                                alt=""
                              />
                            </div>

                            <div className="file-box-header">
                              <div
                                className="file-button"
                                onClick={() => {
                                  window.open(
                                    empSelected?.attachments,
                                    "_blank",
                                  );
                                }}
                              >
                                <img
                                  src={DownloadIcon}
                                  className="file-icon"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>

                          <div className="file-name"></div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {empSelected?.request_type === "Shift Change" && (
                  <>
                    <div
                      className={`profile-detail-table ${
                        isEditingProposedFields ? "tb-editing" : ""
                      }`}
                    >
                      <div className="flex w-full bb-d-t">
                        {renderProposedDropdown(
                          "Proposed Attendance Shift",
                          "attendance_shift",
                          dropDownData?.attendanceShift,
                        )}

                        {renderProposedDropdown(
                          "Proposed Policy Type",
                          "attendance_policy",
                          dropDownData?.attendancePolicy,
                        )}
                      </div>

                      <div className="flex w-full">
                        {renderProposedDropdown(
                          "Proposed Weekly Off",
                          "attendance_weeklyoff",
                          dropDownData?.attendanceWeeklyOff,
                        )}

                        <div className="profile-detail-box">
                          <div className="profile-detail-label">
                            Initiated By
                          </div>
                          <div className="profile-detail-value">
                            {empSelected?.initiator_full_name}
                          </div>
                        </div>

                        <div className="profile-detail-box">
                          <div className="profile-detail-label">
                            Trigger Date
                          </div>
                          <div className="profile-detail-value">
                            {empSelected?.effective_date}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {empSelected?.request_type === "Designation Change" && (
                  <>
                    <div className="profile-detail-table">
                      <div className="flex w-full bb-d-t">
                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Current Designation
                          </div>
                          <div className="profile-detail-value"></div>
                        </div>

                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Proposed Designation
                          </div>
                          <div className="profile-detail-value"></div>
                        </div>
                      </div>

                      <div className="flex w-full">
                        <div className="profile-detail-box br-d-t">
                          <div className="profile-detail-label">
                            Current Manager
                          </div>
                          <div className="profile-detail-value"></div>
                        </div>

                        <div className="profile-detail-box">
                          <div className="profile-detail-label">
                            Current Attendance Shift Type
                          </div>
                          <div className="profile-detail-value"></div>
                        </div>

                        <div className="profile-detail-box">
                          <div className="profile-detail-label">
                            Trigger Date
                          </div>
                          <div className="profile-detail-value">
                            {empSelected?.effective_date}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {empSelected?.request_type === "CTC Revision" && (
                  <CtcRevisionDetails item={empSelected} />
                )}
              </div>
            </div>

            {empSelected?.status !== "Approved" && (
              <div className="remarks-container">
                <InitialsCircle fullName={fullName} size={24} type="profile" />

                <input
                  id="request-attachment-box"
                  type="text"
                  className={"request-attachment-box"}
                  onChange={(e) => setRequestRemarks(e.target.value)}
                  placeholder="Mention a comment along with your request"
                  value={requestRemarks}
                />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default TaskBox;
